import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    Spin, ConfigProvider
} from 'antd';
import getProjects from '../../ApiSeervice';
import { Color } from 'antd/es/color-picker';

function TabProject() {
    const [projects, setProjects] = useState([]);
    const [loadedImages, setLoadedImages] = useState({});

    useEffect(() => {
        async function fetchProjects() {
            const response = await getProjects();
            setProjects(response);
        }

        fetchProjects();
    }, []);

    const handleImageLoad = (id) => {
        setLoadedImages(prev => ({
            ...prev,
            [id]: true
        }));
    };

    return (
        <div className="themesflat-project style-2 isotope-project has-margin mg15 data-effect clearfix">
            {projects.map(data => (
                <div className="project-item architecture building construction" key={data.id}>
                    <div className="inner">
                        <div className="thumb data-effect-item has-effect-icon w40 offset-v-19 offset-h-49">
                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorPrimary: "#5c0a0a"
                                    },
                                }}
                            >
                               
                            <Spin spinning={!loadedImages[data.id]} style={{ color: "#5c0a0a" }}>
                                <img
                                    style={{
                                        height: "22vh",
                                        width: "100%",
                                        objectFit: "cover",
                                        display: loadedImages[data.id] ? 'block' : 'none'
                                    }}
                                    src={data.photos[0].path}
                                    alt="altimage"
                                    onLoad={() => handleImageLoad(data.id)}
                                    onError={() => handleImageLoad(data.id)} // hata olursa da spini kaldırsın
                                />
                                {!loadedImages[data.id] && (
                                    <div style={{ height: "22vh", width: "100%" }} />
                                )}
                            </Spin>
                            </ConfigProvider>


                            <div className="elm-link" />
                            <div className="overlay-effect bg-color-3" />
                        </div>
                        <div className="text-wrap">
                            <h5 className="heading">
                                <Link onClick={() => window.location.href = `/project-detail/${data.id}`}>
                                    {data.title}
                                </Link>
                            </h5>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TabProject;
